import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { CardTranslationEntity } from './CardTranslationEntity'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { BranchTagsMiniEntity } from '@/features/branchTags/domain/entities/BranchTagsMiniEntity'
import type { CardLinkType } from '../enyms/CardLinkType'
import type { CardViewType } from '../enyms/CardViewType'

export class CreateUpdateCardEntity {
  name?: string
  startDate?: Date
  expireDate?: Date | null
  uri?: string | null
  translations?: Array<CardTranslationEntity> | null
  isEnabled?: boolean
  viewType?: CardViewType
  regions?: Array<RegionMiniEntity>
  channel?: ChannelMiniEntity
  branchTags?: Array<BranchTagsMiniEntity>
  linkType?: CardLinkType
  cardRegions?: Array<{
    region?: RegionMiniEntity
    districtIds?: Array<number> | null
  }> | null
  cardPerBranch?: number | null
}
